const ns = 'login';
export const addNamespace = (obj, namespace = ns) =>
    Object.fromEntries(Object.entries(obj).map((v) => [v[0], `${namespace}/${v[1]}`]));
